import { graphql } from "gatsby"
import React, { useState, useEffect } from "react"
import SEO from "../shared/seo"
import Layout from "../shared/components/organisms/layout/layout"
import '../shared/styles/index.scss'
import WhatAreContent from "../components/organisms/what-are-content/what-are-content";
import ModalExpiredPointsGeneric from "../components/molecules/modal-expired-points-generic/modal-expired-points-generic"
import userSessionStorage from "../shared/utils/userSessionStorage";

import ModalFidelization from "../components/molecules/modal-fidelization/modal-fidelization"
import ModalExpiredPointsOffline from "../components/molecules/modal-expired-points/modal-expired-points-offline"

const WhatAre = (props) => {

    // send active modal to layout
    const [modalActive, setModalActive] = useState();
    // var news_info=props.dataProp
    const [isMobile, setMobileBool] = useState(false);
    const [modalPointsActive, setModalPointsActive] = useState(false)

    // send active modal to layout
    const updateDimensions = () => {
        setMobileBool(window.innerWidth < 1024 ? true : false);
    }
    const  imagenesGenericas = props.data.allContentfulNolHomeSegundoNivel.nodes[0].imagenesModales[0]
    const genericModalData = {
        redirect: imagenesGenericas.redireccion,
        imagePC: imagenesGenericas.imagenesDeBanner[0].file.url,
        imageMobile: imagenesGenericas.imagenesDeBanner[1].file.url
    }
    const tieneModalPuntos = props.data.allContentfulNolHomeSegundoNivel.nodes[0].tieneModal
    const session = new userSessionStorage()


    useEffect(() => {
        updateDimensions();
        window.addEventListener("resize", updateDimensions);
        return () => {
            window.removeEventListener("resize", updateDimensions);
        }
    }, [])
    useEffect(() => {
		const modalPointsGeneric = sessionStorage.getItem('modalPointsGeneric')
		if (modalPointsGeneric === null && !session.getUserInfo()) {
			setModalPointsActive(true)
			sessionStorage.setItem('modalPointsGeneric', 'showed')
		}
	}, [])
    

  return (
    <Layout
      mobile={isMobile}
      modalActive={modalActive}
      title="Mis Puntos - ¿Qué son?"
    >
      <SEO title="Mis Puntos - ¿Qué son?" url={"/mis-puntos/que-son/"} />
      <ModalFidelization />

            <WhatAreContent
                mobile={isMobile}
                setModalActive={setModalActive}
            />
            {tieneModalPuntos && modalPointsActive && <ModalExpiredPointsGeneric
                imagesModal={genericModalData}
                onClose={() => {
                    setModalPointsActive(false)
                }}
            />}
        </Layout>
    )
}

export const query = graphql`
query GET_MODAL_POINTS_GENERIC($locale: String!) {
    allContentfulNolHomeSegundoNivel(filter: { node_locale: { eq: $locale }, titulo: {eq: "Mis Puntos"} }) {
        nodes {
            tieneModal
            imagenesModales {
                redireccion
                imagenesDeBanner {
                file {
                    url
                }
                description
                }
            }
        }
    }
}`
export default WhatAre;
